import { useMemo } from 'react';

import { UserScopedRole } from 'common/api-types/director';
import { useCurrentUserQuery } from 'common/query/useCurrentUserQuery';

type WmRoleCheck = {
  role?: string;
  scopeType?: UserScopedRole['scopeType'];
  scopeValue?: string;
};

export const useCurrentUserWmRoles = () => {
  const { data: userInfo, isLoading, error } = useCurrentUserQuery();

  const roles = useMemo(() => userInfo?.roles || [], [userInfo?.roles]);

  const checkWmRole = useMemo(
    () => (check: WmRoleCheck) => {
      if (!roles.length) return false;

      return roles.some((userRole: UserScopedRole) => {
        if (check.role && userRole.role !== check.role) {
          return false;
        }

        if (check.scopeType && userRole.scopeType !== check.scopeType) {
          return false;
        }

        if (check.scopeValue && userRole.scopeValue !== check.scopeValue) {
          return false;
        }

        return true;
      });
    },
    [roles],
  );

  const hasWmRole = useMemo(() => (role: string) => checkWmRole({ role }), [checkWmRole]);

  return {
    roles,
    checkWmRole,
    hasWmRole,
    isLoading,
    error,
  };
};
